(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-variant-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('card-variant-picker')) {
    customElements.define('card-variant-picker', class extends HTMLElement {
      connectedCallback() {
        queueMicrotask(() => {
          if (!this.isConnected) return;
          this.card = this.closest('product-card');
          if (!this.card) return;
          if (!this.initialized) {
            this.initialized = true;
            this.addEventListener('click', event => {
              const button = event.target.closest('button[data-flavor], button[data-weight]');
              if (!button || button.disabled) return;
              event.preventDefault();
              event.stopPropagation();
              if (button.hasAttribute('data-flavor')) this.chooseFlavor(button.dataset.flavor);
              else this.chooseWeight(button.dataset.weight);
            });
            this.addEventListener('change', event => {
              if (!event.target.matches('[data-flavor-select]')) return;
              event.stopPropagation();
              this.chooseFlavor(event.target.value);
            });
            this.contentObserver = new MutationObserver(() => this.readData());
            this.linkObserver = new MutationObserver(() => {
              const link = this.card.querySelector('[ref="productCardLink"]');
              const id = (link ? new URL(link.href).searchParams.get('variant') : null) || this.dataset.initialVariant;
              const variant = this.variants?.find(item => item.id === id);
              if (variant && variant.id !== this.selected?.id) this.select(variant);
            });
          }
          this.readData();
          this.watch();
        });
      }
      watch() {
        this.contentObserver.observe(this, {
          childList: true, subtree: true, attributes: true,
          attributeFilter: ['data-initial-variant', 'data-flavor-index', 'data-weight-index']
        });
        const link = this.card.querySelector('[ref="productCardLink"]');
        if (link) this.linkObserver.observe(link, { attributes: true, attributeFilter: ['href'] });
      }
      disconnectedCallback() {
        this.contentObserver?.disconnect();
        this.linkObserver?.disconnect();
      }
      readData() {
        const source = this.querySelector('[data-card-variants]')?.textContent;
        if (!source) return;
        if (source === this.source && this.initialId === this.dataset.initialVariant) {
          this.refresh();
          return;
        }
        this.source = source;
        this.initialId = this.dataset.initialVariant;
        this.variants = JSON.parse(source);
        this.flavorIndex = Number(this.dataset.flavorIndex);
        this.weightIndex = Number(this.dataset.weightIndex);
        this.selected = this.variants.find(item => item.id === this.initialId) || this.variants[0];
        this.chosen = false;
        this.refresh();
      }
      inContext(variant) {
        return variant.options.every((value, index) =>
          index === this.flavorIndex || index === this.weightIndex || value === this.selected?.options[index]
        );
      }
      flavorVariants(flavor) {
        return this.variants.filter(variant => this.inContext(variant) && variant.options[this.flavorIndex] === flavor);
      }
      weightVariants(weight) {
        return this.variants.filter(variant => this.inContext(variant) &&
          variant.options[this.weightIndex] === weight &&
          (this.flavorIndex < 0 || variant.options[this.flavorIndex] === this.selected?.options[this.flavorIndex])
        );
      }
      chooseFlavor(flavor) {
        const candidates = this.flavorVariants(flavor);
        const sameWeight = candidates.find(item => item.available &&
          (this.weightIndex < 0 || item.options[this.weightIndex] === this.selected?.options[this.weightIndex]));
        const variant = sameWeight || candidates.find(item => item.available) || candidates[0];
        if (variant) this.select(variant);
      }
      chooseWeight(weight) {
        const candidates = this.weightVariants(weight);
        const variant = candidates.find(item => item.available) || candidates[0];
        if (variant) this.select(variant);
      }
      refresh() {
        if (!this.selected) return;
        const soldOut = this.dataset.soldOut;
        for (const button of this.querySelectorAll('[data-flavor]')) {
          const candidates = this.flavorVariants(button.dataset.flavor);
          button.hidden = candidates.length === 0;
          button.disabled = !candidates.some(item => item.available);
          button.setAttribute('aria-pressed', String(this.selected.options[this.flavorIndex] === button.dataset.flavor));
          button.title = button.dataset.flavor + (button.disabled ? ' — ' + soldOut : '');
        }
        const select = this.querySelector('[data-flavor-select]');
        if (select) {
          for (const option of select.querySelectorAll('option[data-base-label]')) {
            const candidates = this.flavorVariants(option.value);
            option.hidden = candidates.length === 0;
            option.disabled = !candidates.some(item => item.available);
            const label = option.dataset.baseLabel + (option.disabled ? ' — ' + soldOut : '');
            if (option.textContent !== label) option.textContent = label;
          }
          select.value = this.chosen ? this.selected.options[this.flavorIndex] : '';
        }
        for (const button of this.querySelectorAll('[data-weight]')) {
          const candidates = this.weightVariants(button.dataset.weight);
          button.hidden = candidates.length === 0;
          button.disabled = !candidates.some(item => item.available);
          button.setAttribute('aria-pressed', String(this.selected.options[this.weightIndex] === button.dataset.weight));
          button.title = button.dataset.weight + (button.disabled ? ' — ' + soldOut : '');
        }
        const status = this.querySelector('[data-variant-status]');
        const message = this.selected.available ? '' : soldOut;
        if (status.textContent !== message) status.textContent = message;
        status.hidden = this.selected.available;
      }
      select(variant) {
        this.selected = variant;
        this.chosen = true;
        this.refresh();
        for (const container of this.card.querySelectorAll('product-price [ref="priceContainer"]')) {
          if (container.closest('quick-add-component, dialog')) continue;
          container.innerHTML = variant.priceHtml;
          container.setAttribute('aria-live', 'polite');
          container.setAttribute('aria-atomic', 'true');
        }
        if (typeof this.card.applyVariantToLinks === 'function') {
          this.card.applyVariantToLinks(variant.id);
        } else {
          for (const link of this.card.querySelectorAll('a[ref="productCardLink"], a[ref="productTitleLink"], a[ref="cardGalleryLink"]')) {
            const url = new URL(link.href);
            url.searchParams.set('variant', variant.id);
            link.href = url.href;
          }
        }
        this.updateImage(variant);
      }
      updateImage(variant) {
        const gallery = this.card.querySelector('[ref="cardGallery"]');
        if (!gallery || !variant.image) return;
        gallery.removeAttribute('on:pointerenter');
        gallery.removeAttribute('on:pointerleave');
        const slideshow = gallery.querySelector('slideshow-component');
        const slide = slideshow?.querySelector('[slide-id="' + variant.mediaId + '"]');
        if (slide && typeof slideshow.select === 'function') {
          for (const item of slideshow.querySelectorAll('slideshow-slide')) {
            item.hidden = item !== slide;
            item.setAttribute('aria-hidden', String(item !== slide));
          }
          slide.hidden = false;
          slide.setAttribute('aria-hidden', 'false');
          slideshow.select({ id: variant.mediaId }, undefined, { animate: false });
        } else {
          const image = gallery.querySelector('slideshow-slide:not([hidden]) img, .product-media img');
          if (image) {
            image.removeAttribute('srcset');
            image.src = variant.image;
            image.alt = variant.alt || this.dataset.productTitle;
          }
        }
        this.card.dataset.featuredMediaUrl = variant.image;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
